import { render, staticRenderFns } from "./TituloRelatorioFichaSocioeconomica.vue?vue&type=template&id=2471299b&"
import script from "./TituloRelatorioFichaSocioeconomica.vue?vue&type=script&lang=js&"
export * from "./TituloRelatorioFichaSocioeconomica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports